import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EnvironmentFlagsService } from '../services/environment-flags.service';
import { AuthService } from '../services/auth.service';

/**
 * 4.6 (X10, DCMPDEV-759 / DCM-367): Parent Portal v1 has no post-start surface.
 * While PARENT_POST_START_UPDATES is off, every post-start route (My child's
 * forms and its update/history/contacts pages, the Individual Plan) redirects to
 * the children page, where the started child shows "More features are coming
 * soon." Account and security settings are NOT behind this guard.
 *
 * Fail CLOSED: a missing flag or a failed read keeps the surfaces closed.
 */
export const postStartEnabledGuard: CanActivateFn = (): ReturnType<CanActivateFn> => {
  const flags = inject(EnvironmentFlagsService);
  const router = inject(Router);
  const auth = inject(AuthService);

  // No auth yet: authGuard owns that decision; don't double-redirect.
  if (!auth.isAuthenticated) return true;

  return flags.parentPostStartUpdates().then((enabled) =>
    enabled ? true : router.parseUrl('/dashboard/enrollment'),
  );
};
